/* 浅川木工 カスタムJS（2026-09-20）
   ------------------------------------------------------------------
   カートドロワーを閉じたとき、開く前に見ていた位置へ戻す。

   【なぜ必要か】
   Horizonはスマホでドロワーを開くとき history.pushState を積み、閉じるときに
   history.back() を呼ぶ（Androidの戻るボタンでドロワーを閉じられるようにするため。
   assets/cart-drawer.js の #handleHistoryOpen / #handleHistoryClose）。
   一方 assets/dialog.js は「開いた時点のスクロール位置」を覚えていて、
   閉じるときに window.scrollTo で戻す。
   この2つが競合し、ブラウザ側のスクロール復元（history.scrollRestoration = 'auto'）が
   Horizonの復元を上書きするため、閉じるとページの別の場所に飛ばされる。
   pushState はドロワーが開いた後＝body が position:fixed（scrollY=0）の状態で
   積まれるので、ブラウザは「0」を復元しようとするのが原因。

   【方針】
   dialog:open / dialog:close は Horizon が公開しているイベント（assets/dialog.js）。
   内部APIやShadow DOMには触れていないので、テーマ更新でも比較的壊れにくい。
   history.scrollRestoration は変更しない（変えるとページ間の「戻る」で
   スクロール位置が復元されなくなり、商品一覧への戻りが悪化するため）。
   ------------------------------------------------------------------ */
(() => {
  const init = () => {
    const drawer = document.querySelector('cart-drawer-component');
    if (!drawer) return;

    let savedY = null;

    drawer.addEventListener('dialog:open', () => {
      // 開いた直後は body が position:fixed になっていて window.scrollY は 0。
      // dialog.js が body.style.top に「-<元の位置>px」を入れるので、そこから読む。
      const top = document.body.style.top;
      savedY = top ? Math.abs(parseInt(top, 10)) : window.scrollY;
    });

    drawer.addEventListener('dialog:close', () => {
      if (savedY === null) return;
      const y = savedY;
      savedY = null;

      // history.back() によるブラウザ側の復元は popstate のタイミングで走る。
      // それより後に上書きし直したいので、次フレームと少し遅らせた回で試す。
      // テーマは html に scroll-behavior:smooth を当てているため、
      // 戻すあいだだけ auto にしてアニメーションを挟まずに一発で移動させる
      // （smooth のままだと途中で止まり、数十pxずれた位置に着地する）。
      const restore = () => {
        if (Math.abs(window.scrollY - y) <= 2) return;
        const html = document.documentElement;
        const previous = html.style.scrollBehavior;
        html.style.scrollBehavior = 'auto';
        window.scrollTo(0, y);
        html.style.scrollBehavior = previous;
      };
      requestAnimationFrame(restore);
      setTimeout(restore, 120);
      setTimeout(restore, 400);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
